import { Component, OnInit, OnDestroy } from '@angular/core';
import { CognitoServiceService } from './services/auth/cognito-service.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Modernize Angular Admin Tempplate';
  isValidatingCredentials = false;
  private destroy$ = new Subject<void>();

  constructor(private cognitoService: CognitoServiceService) {}

  ngOnInit(): void {
    // Suscribirse al estado de loading del servicio de autenticación
    this.cognitoService.isLoading$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isLoading => {
        this.isValidatingCredentials = isLoading;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
